import { JSX } from "react";
import { IbssComponent } from "../../Core/BaseComponent/IbssComponent";
import { Navigate, Route } from "react-router-dom";
import { IRouterProps, withRouting } from "@iconics/components";
import { StringHelper } from "../../../Common/StringHelper";
import { ILegacyRoute, IRoute } from "./Routes";

export class LegacyRedirect extends IbssComponent<IProps, IState>
{
    private string = new StringHelper();

    private mapLagacyPathToNewPath(): string
    {
        const { legacyPath, route } = this.props;
        let path = route.path;
        let query = '';

        const originalRouteParams = new Map(Object.entries(this.props.params));
        const originalQuery = this.props.location.search.replace(/^\?/, '');
        const originalQueryParams = new Map(originalQuery.split('&').filter(i => !!i).map(i => [i.split('=')[0], i.split('=')[1]]));
        const allOriginalParams = new Map([...Array.from(originalRouteParams), ...Array.from(originalQueryParams)]);
        const parameterMapWithLowercaseKeys = new Map(Object.entries(legacyPath.parameterMap ?? {}).map(i => [i[0].toLocaleLowerCase(), i[1]]));

        for (const param of Array.from(allOriginalParams))
        {
            const paramAlias = parameterMapWithLowercaseKeys.get(this.string.toConcatenatedLowercase(param[0])) ?? param[0];
            const paramPlaceholder = ':' + paramAlias;
            const paramValue = param[1] ?? '';

            if (path.includes(paramPlaceholder))
            {
                path = path.replace(new RegExp(paramPlaceholder, 'gi'), paramValue); //  assumption that paramAlias conatins no reg-ex chars
            }
            else if (paramAlias != '')
            {
                query = [query, `${paramAlias}=${paramValue}`].filter(i => !!i).join('&');
            }
        }

        const pathAndQuery = [path, query].filter(i => !!i).join('?');
        return pathAndQuery;
    }

    public render(): JSX.Element
    {
        const { legacyPath, route } = this.props;

        return (
            <Navigate
                to={this.mapLagacyPathToNewPath()}
                replace
            />
        );
    }
}

export default withRouting<IRawProps>(LegacyRedirect);

export interface IProps extends IRawProps, IRouterProps<{ [key: string]: string | undefined }> { }

export interface IRawProps
{
    route: IRoute<any>;
    legacyPath: ILegacyRoute;
}

export interface IState { }
